export function initConsoleMessage(): void {
  console.log(
    '%c' +
      ' ██████╗ ██████╗  ██████╗ ██████╗ ███████╗███╗   ██╗\n' +
      '██╔════╝██╔═══██╗██╔═══██╗██╔══██╗██╔════╝████╗  ██║\n' +
      '██║     ██║   ██║██║   ██║██████╔╝█████╗  ██╔██╗ ██║\n' +
      '██║     ██║   ██║██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║\n' +
      '╚██████╗╚██████╔╝╚██████╔╝██║     ███████╗██║ ╚████║\n' +
      ' ╚═════╝ ╚═════╝  ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝\n' +
      '    S E C U R I T Y   S Y S T E M   v3.0\n',
    'color: #14B8A6; font-family: monospace; font-size: 10px; font-weight: bold;'
  );

  console.log(
    '%c⚠ ACCESS DETECTED',
    'color: #EF4444; font-size: 28px; font-weight: 900; text-shadow: 2px 2px 0 #7F1D1D;'
  );

  console.log(
    '%c[SYSTEM] Connection established from an unauthorized terminal.\n' +
      '[SYSTEM] Logging IP, fingerprint and session hash...\n' +
      '[SYSTEM] Activating monitoring protocol COOPEN-SEC-7...',
    'color: #F59E0B; font-family: monospace; font-size: 11px;'
  );

  console.log(
    '%c"Careful, cybernaut... if you gaze into the abyss, it gazes back."\n— Friedrich Nietzsche',
    'color: #EC4899; font-style: italic; font-size: 13px; padding: 8px 0;'
  );

  console.log(
    '%c' +
      'If someone told you Coopen does not care about the security\n' +
      'of its sites... well, that someone clearly never saw the\n' +
      'log files, the cups of cold coffee and the 4am eye bags.\n' +
      'So no, do not paste random code here. 🛡️',
    'color: #94A3B8; font-family: monospace; font-size: 12px; line-height: 1.6;'
  );

  console.log(
    '%c┌────────────────────────────────────────────────────┐\n' +
      '│  Coopen SMM — AI Social Media Content Generation   │\n' +
      '│  Powered by Coopen Studio                          │\n' +
      '│  Stack: React + Cloudflare Workers + D1 + R2       │\n' +
      '│  AI: OpenAI GPT-4o + KIE.ai (z-image, Flux)        │\n' +
      '└────────────────────────────────────────────────────┘',
    'color: #14B8A6; font-family: monospace; font-size: 11px;'
  );

  console.log(
    '%cWant to see more Coopen projects? 👉 https://CoopenStudio.com/',
    'color: #3B82F6; font-size: 13px; font-weight: bold;'
  );

  console.log(
    '%c%s',
    'font-size: 1px;',
    'If you are reading this, you are one of us. Send a CV to coopenstudio@gmail.com 😎'
  );
}
